function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWavyLine = function SvgWavyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 832,
    height: 167,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 7,
    d: "M-217 163.719c37.226-18.891 143.166-49.666 269.123-21.631C209.57 177.131 246.185 49.505 345.962 73.3c99.777 23.794 169.346-77.874 323.131-38.937C792.121 65.513 900.381-8.9 939.132-50",
    style: {
      stroke: "#fff",
      strokeOpacity: 1
    }
  }));
};
export { SvgWavyLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODMyIiBoZWlnaHQ9IjE2NyIgdmlld0JveD0iMCAwIDgzMiAxNjciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0tMjE3IDE2My43MTlDLTE3OS43NzQgMTQ0LjgyOCAtNzMuODMzNyAxMTQuMDUzIDUyLjEyMzQgMTQyLjA4OEMyMDkuNTcgMTc3LjEzMSAyNDYuMTg1IDQ5LjUwNDkgMzQ1Ljk2MiA3My4yOTk2QzQ0NS43MzkgOTcuMDk0MiA1MTUuMzA4IC00LjU3NDEyIDY2OS4wOTMgMzQuMzYyN0M3OTIuMTIxIDY1LjUxMjIgOTAwLjM4MSAtOC45MDAxNCA5MzkuMTMyIC01MCIgc3Ryb2tlPSJ3aGl0ZSIgc3R5bGU9InN0cm9rZTp3aGl0ZTtzdHJva2Utb3BhY2l0eToxOyIgc3Ryb2tlLXdpZHRoPSI3Ii8+Cjwvc3ZnPgo=";